import React, { useEffect, useState, useRef } from 'react';
import logo from '../../images/logo_principal.png'
import '../../css/Components/Profile/Profile.css';
import { Link as Anchor } from 'react-router-dom';
import baseURL from '../url.js';
export default function Profile({ info }) {
    const [informacion, setInformacion] = useState({});

    useEffect(() => {
        cargarContacto();

    }, [info]);


    const cargarContacto = () => { setInformacion(info) };

    return (
        <div className='profileContain'>
            <img src={logo} alt="" />
            <h2>{informacion?.razon_social}</h2>

            <div className='socials'>
                <Anchor to={informacion?.instagram} target="_blank"><i className='fa fa-instagram'></i></Anchor>
                <Anchor to={`tel:${informacion?.telefono}`} target="_blank"><i className='fa fa-whatsapp'></i></Anchor>
                <Anchor to={informacion?.facebook} target="_blank"><i className='fa fa-facebook'></i></Anchor>
            </div>

            <div className='profileText'>
                {/* <Anchor to={`/Productos`} >
                    Filtros Personalizados
                </Anchor> */}
                <Anchor to={`mailto:${informacion?.email}`} target="_blank">{informacion?.email}</Anchor>
                <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(informacion?.direccion)}`} target="_blank">{informacion?.direccion}</Anchor>
                <h5>RUC. {informacion?.ruc}</h5>

            </div>
        </div>
    )
}
